import { useAuth0 } from '@auth0/auth0-react';
import { useCallback } from 'react';

import {
  LoginWithRedirectCallbackOptions,
  useLoginWithRedirectCallback,
} from '../../../auth/redirect/useLoginWithRedirectCallback';
import { LoginExperience } from '../../../auth/types';

type ClientLoginCallbackOptions = Pick<Partial<LoginWithRedirectCallbackOptions>, 'openUrl' | 'returnTo'>;

export function useClientLogin(): {
  handleLogin: (options?: ClientLoginCallbackOptions) => void;
  isAuthenticated: boolean;
} {
  const { isAuthenticated } = useAuth0();
  const loginWithRedirect = useLoginWithRedirectCallback();
  const handleLogin = useCallback(
    ({ openUrl, returnTo }: ClientLoginCallbackOptions = {}) => {
      loginWithRedirect({
        openUrl,
        loginExperience: LoginExperience.CLIENT,
        returnTo: returnTo ?? location.pathname,
      });
    },
    [loginWithRedirect],
  );

  return { handleLogin, isAuthenticated };
}
